import type {SharedData} from '@gaia/types';
import classes from '@map/Map/Map.module.css';
import {memo} from 'react';

import {MapOrientationControls} from './MapOrientationControls';
import {ScaleControl} from './ScaleControl';
import {SearchBoxControl} from './SearchBoxControl';

export interface ControlsProps {
    is3D: boolean;
    map: mapboxgl.Map | undefined;
    onKnownRoutesChange: SetState<Record<number, KnownRouteTag>>;
    onSidebarChange: SetState<SidebarState>;
    interactionType: InteractionState['type'];
    onInteractionChange: SetState<InteractionState>;
    showSearchBoxControl: boolean;
    setIs3D: SetState<boolean>;
    setSelections: SetState<SelectionState[]>;
    sharedData: SharedData;
    show3DControl: boolean;
    showFullscreenControl: boolean;
    showGeolocateControl: boolean;
    userLayers: UserLayer[] | undefined;
}

export const Controls = memo(function Controls(props: ControlsProps) {
    const isSmall = window.innerWidth <= 450;

    return (
        <>
            {props.showSearchBoxControl && (
                <div className={classes.search}>
                    <SearchBoxControl
                        resultsContainerStyle={{
                            maxHeight: 'calc(100vh - 100px)',
                            ...(isSmall && {width: '100%'}),
                        }}
                        interactionType={props.interactionType}
                        onInteractionChange={props.onInteractionChange}
                        setSelections={props.setSelections}
                        onSidebarChange={props.onSidebarChange}
                        center={props.map?.getCenter().wrap()}
                        map={props.map}
                    />
                </div>
            )}

            <ScaleControl map={props.map} />

            <MapOrientationControls {...props} />
        </>
    );
});
